<template>
  <div class="container">
    <div class="mt-4">
      <div class="col-12 mt-2 cust">
        <div class="row">
          <div class="col-sm-12 h3">Add Company</div>
        </div>
        <div class="row shadow py-3 report">
          <div class="col-md-6 col-sm-12 px-3 py-2">
            <label class="labelClass">Email Address *</label>
            <br />
            <input
              class="form-control"
              type="email"
              v-model="email"
              placeholder="Email"
              @keyup="validateEmail(email)"
              required
            />
          </div>
          <div class="col-md-6 col-sm-12 px-3 py-2">
            <label class="labelClass">Name</label>
            <br />
            <input class="form-control" type="email" v-model="name" placeholder="Name" />
          </div>
          <div class="col-md-6 col-sm-12 px-3 py-2">
            <label class="labelClass">Password (minimum 8 characters)*</label>
            <br />
            <input
              class="form-control"
              type="password"
              v-model="password"
              placeholder="Password"
              @keyup="pwdLenth"
              minlength="8"
              required
            />
          </div>
          <div class="col-md-4 col-sm-12 px-3 py-2">
            <label class="labelClass">Company Name *</label>
            <br />
            <input
              class="form-control"
              type="text"
              v-model="companyName"
              placeholder="Company Name"
              required
            />
          </div>
          <div class="col-md-2 col-sm-12 my-2">
            <label class="labelClass">Type *</label>
            <br />
            <select class="custom-select form-control border" v-model="devType" required>
              <option value="i">Indoor</option>
              <option value="o">Outdoor</option>
              <option value="io">Both</option>
            </select>
          </div>
          <div class="col-md-6 col-sm-12 px-3 py-2">
            <label class="labelClass">Company Address *</label>
            <br />
            <textarea
              rows="4"
              class="form-control"
              type="text"
              style="height: auto !important"
              v-model="companyAddress"
              placeholder="Company Address"
              required
            ></textarea>
            <!-- <input class="form-control" type="text" v-model="companyAddress" placeholder="Company Address"/> -->
          </div>
          <div class="col-md-6 col-sm-12 mt-auto text-right px-3 py-2">
            <div class="row">
              <div class="col-sm-6">
                <label>lat</label>
                <input class="form-control" type="number" v-model="lat" placeholder="lat" />
              </div>
              <div class="col-sm-6">
                <label class="labelClass">long</label>
                <input class="form-control" type="number" v-model="lng" placeholder="long" />
              </div>
            </div>
          </div>
          <div class="col-md-12 col-sm-12 mt-auto text-center px-3 py-2">
            <button @click="submitForm" class="btn btn-danger">Submit</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { apiCall } from "@/utils/api";
import swal from "sweetalert";
import swtAlrt from "../../../mixins/swtalrt";
/* eslint-disable */
export default {
  components: {},
  data() {
    return {
      companyAddress: "",
      companyName: "",
      devType: "",
      email: "",
      emailValid: "",
      password: "",
      pwd: 0,
      name: "",
      customer: "",
      lat: "",
      lng: "",
      companies: {},
    };
  },
  mounted() {
    this.getAllCustomer();
  },
  mixins: [swtAlrt],
  methods: {
    submitForm() {
      if (
        this.devType &&
        this.emailValid &&
        this.pwd &&
        this.companyName &&
        this.companyAddress
      ) {
        let body = {
          company: {
            name: this.companyName,
            address: this.companyAddress,
            lat: this.lat,
            lng: this.lng,
          },
          user: {
            name: this.name,
            password: this.password,
            email: this.email,
            type: this.devType,
            isAdmin: true,
            lat: this.lat,
            lng: this.lng,
          },
        };
        apiCall({ url: "company", data: body, method: "post" })
          .then((resp) => {
            this.swalSuccess();
          })
          .catch((err) => {
            this.swalNetworkError();
          });
      } else {
        if (this.pwd && this.emailValid) {
          this.swalError();
        } else if (!this.emailValid) {
          this.swalEmailError();
        } else if (!this.pwd) {
          this.swalPwdError();
        }
      }
    },
    getAllCustomer() {
      apiCall({ url: "company", method: "get" })
        .then((resp) => {
          this.companies = resp.data;
        })
        .catch((err) => {
          //   console.log(err);
        });
    },
  },
};
</script>

<style scoped>
</style>
